import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import Auth from "./Modules/Auth.js";
import Dashboard from "./Modules/Dashboard.js";
import Province from "./Modules/Province.js";
import Order from "./Modules/Order.js";
import User from "./Modules/User.js";
import Report from "./Modules/Report.js";
import Product from "./Modules/Product.js";
import axios from "axios";
import VuexPersistence from "vuex-persist";
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({
    Auth: {
      refeshToken: state.Auth.refeshToken,
      refeshProvince: state.Auth.refeshProvince,
      refeshStoreID: state.Auth.refeshStoreID,
      userInfo: state.Auth.userInfo,
      isSunmi: state.Auth.isSunmi
    },

  })
});

export const store = new Vuex.Store({
  plugins: [vuexLocal.plugin],
  state: {
    baseAPIURL: null,
    baseAPIURL2: null
  },
  mutations: {
    verifyingToken(state, instance) {
      if (process.env.VUE_APP_BACKEND_API_VERSION) {
        state.baseAPIURL = instance.replace(/api\/v[0-9]/g, `api/v${process.env.VUE_APP_BACKEND_API_VERSION}`)
      } else {
        state.baseAPIURL = instance
      }
    },
    setBaseAPIURL2(state, instance) {
      state.baseAPIURL2 = instance;
    }
  },
  modules: {
    Report,
    Order,
    User,
    Auth,
    Dashboard,
    Product,
    Province
  }
});

export const globalAxios = axios.create({
  headers: {
    "Content-Type": "application/json"
  }
});
export const coreInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL,
  headers: {
    "Content-Type": "application/json"
  }
});
